/* VERIFYTOKET */
export const GET_VERIFYTOKET = "GET_VERIFYTOKET"
export const GET_VERIFYTOKET_SUCCESS = "GET_VERIFYTOKET_SUCCESS"
export const GET_VERIFYTOKET_FAIL = "GET_VERIFYTOKET_FAIL"